import {useTestRoom} from "../../../../../hooks/useTestRoom";
import React, {useEffect, useMemo, useRef, useState} from "react";
import {Divider, Grid, Stack, Typography} from "@mui/joy";
import {Question, QuestionGroup, QuestionType, RawQuestion} from "../../../../../models/question";
import IeltsWritingTaskQuestionComponent from "../question/IeltsWritingTaskQuestionComponent";

const IeltsWritingTestRoomComponent = () => {
    const testRoom = useTestRoom()
    const [question, setQuestion] = useState<Question>()

    const QuestionComponent = (props: { question: Question }) => {
        return <IeltsWritingTaskQuestionComponent question={props.question}/>
    }

    useEffect(() => {
        setQuestion(testRoom.questions?.find(value => value.subSectionNumber === testRoom.currentSubsectionNumber) as QuestionGroup)
    }, [testRoom.currentSubsectionNumber, testRoom.questions])

    return <Grid container spacing={3} sx={{overflowY: {xs: "auto", md: "hidden"}, height: "100%"}}>
        <Grid xs={12} md={6}>
            <Stack gap={3}>
                <Typography level={"title-lg"}>
                   Task {question?.subSectionNumber}
                </Typography>

                <Typography level={"title-md"}>
                    {question?.instruction}
                </Typography>

                <Typography textAlign={"justify"} level={"body-md"} textColor={"text.tertiary"}>
                    <i>{question?.content}</i>
                </Typography>
            </Stack>
        </Grid>

        <Grid xs={12} md={6} height={"100%"} sx={{overflowY: null, overflowX: "hidden"}}>
            <Stack gap={4} boxSizing={"border-box"}>
                <QuestionComponent question={question}/>
            </Stack>
        </Grid>

    </Grid>
}

export default React.memo(IeltsWritingTestRoomComponent)